import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as ExamIcon } from "../../../images/examimage/examicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewExam from "./ViewExam";
import { toast } from "react-toastify";
import ExamInBulk from "../../../../BulkCSVFilder/ExamInBulk.csv"

function Exam() {
  const classes = useStyles();
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = ExamInBulk;
        link.setAttribute("download", "ExamsInBulk.csv");
    
        // Append to the document and trigger the download
        document.body.appendChild(link);
        link.click();
    
        // Check if the download started (link exists in document)
        if (document.body.contains(link)) {
          toast.success("Sample file for adding exam in bulk has been downloaded");
        } else {
          toast.error("Failed to download the bulk exam file. Please try again.");
        }
    
        // Clean up
        link.parentNode.removeChild(link);
      };
  const Heading = [
    {
      id: 1,
      pageicon: <ExamIcon />,
      mainheading: "Exam",
      addbtntext: "Create New Exam",
      showDownloadButton: true,
      onDownload: handleDownload,
      subhead: "Want to Add in Bulk ?",
      downloadexam: "true",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path: "/admin/addexam",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <PageHeader Heading={Heading} />
      <ViewExam />
    </div>
  );
}
export default Exam;
